module.exports = new __parcel__URL__("star_laboratory_level_3.7e4ed7a0.png").toString();